import { render, staticRenderFns } from "./Navegacion.vue?vue&type=template&id=2745980c"
import script from "./Navegacion.vue?vue&type=script&lang=js"
export * from "./Navegacion.vue?vue&type=script&lang=js"
import style0 from "./Navegacion.vue?vue&type=style&index=0&id=2745980c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports